module.exports = __webpack_public_path__ + "static/media/leggings.2ed6641f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/leggings.png
// module id = 373
// module chunks = 0